// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Sad = function Sad(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('circle', { cx: '5.397', cy: '6.67', r: '.948' }),
    React.createElement('circle', { cx: '10.591', cy: '6.67', r: '.948' }),
    React.createElement('path', { d: 'M14.756 5.7a7.143 7.143 0 1 0-.347 5.427 7.065 7.065 0 0 0 .347-5.427zm-1.036 5.1a6.352 6.352 0 1 1 .652-2.8 6.389 6.389 0 0 1-.652 2.8z' }),
    React.createElement('path', { d: 'M8 8.718a5.094 5.094 0 0 0-4.128 2.109 5.02 5.02 0 0 0 .593.715 4.244 4.244 0 0 1 .558-.7 4.209 4.209 0 0 1 5.953 0 4.245 4.245 0 0 1 .558.7 5.036 5.036 0 0 0 .593-.715A5.094 5.094 0 0 0 8 8.718z' })
  );
};

Sad.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Sad;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Sad.js
// module id = 1058
// module chunks = 1